import { render, staticRenderFns } from "./CarouselGallery.vue?vue&type=template&id=68d187f2&scoped=true&"
import script from "./CarouselGallery.vue?vue&type=script&lang=js&"
export * from "./CarouselGallery.vue?vue&type=script&lang=js&"
import style0 from "./CarouselGallery.vue?vue&type=style&index=0&id=68d187f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d187f2",
  null
  
)

export default component.exports